export const HISTORIC_NEWS_MODERATOR_EMAIL = 'mikkergp@proton.me';

export const canModerateHistoricNews = (email?: string) => {
  const token = window.localStorage.getItem('user');
  return Boolean(token) && email?.trim().toLowerCase() === HISTORIC_NEWS_MODERATOR_EMAIL;
};

export const historicNewsAuthHeaders = (): HeadersInit => {
  const token = window.localStorage.getItem('user');
  return token ? { Authorization: `Bearer ${token}` } : {};
};
